import { Icon } from "@/components/icons/Icon";
import { useTranslate } from "@/hooks/use-translate/useTranslate";

const BloquedAnswer = () => {
  const translate = useTranslate();
  return (
    <div className="flex border border-dashed border-ib-gray-borders items-center justify-center py-12  h-32">
      <div className="text-ib-gray-dark-2 flex flex-col items-center justify-center">
        <Icon name="lockClose" className="size-4" />
        <h4 className="text-md">{translate("blocked")}</h4>
      </div>
    </div>
  );
};

export default BloquedAnswer;
